// @ts-nocheck
import DuplicatePopup from '@jo-v1/components/DuplicatePopup';
import JoComparisonBanner from '@jo-v1/components/JoComparisonBanner';
import JoComparisonModal from '@jo-v1/components/JoComparisonModal';
import { NoResults } from '@jo-v1/components/NoResults';
import { RecommenderPopup } from '@jo-v3/components';
import JoEmbeddedRecommender from '@jo-v3/features/JoEmbeddedRecommender';
import { type FC } from 'react';

import { ALGOLIA_BASE_INDEX_NAME } from '@core/services/AlgoliaService/v2';
import UserExperienceSurvey from '@core/shared/features/UserExperienceSurvey';
import { AddActiveProspectScript } from '@core/utils/scripts/AddActiveProspectScript';

import type { EduResultsProps } from '../eduResults/types';
import styles from './JoV3EduResults.module.css';
import ResultsList from './components/ResultsList';
import SubmissionSlideOut from './components/SubmissionSlideOut';

const JoV3EduResultsUI: FC<EduResultsProps> = ({
  showEmbeddedRecommender,
  recommenderData,
  isActiveProspectScriptRequired,
  showDuplicatePopup,
  dcsConsolidationResults,
  searchClient,
  popupData,
  popupEventing,
  exactResults,
  consolidatedResults,
  showUgToGradResultsPageABTest,
  unborrowedMatches,
  subject,
  isComparisonTest,
  showRecommenderPopup,
  showUserExperienceSurvey,
}) => (
  <>
    {/* Handle Trusted Certificate */}
    {isActiveProspectScriptRequired && <AddActiveProspectScript />}
    {showDuplicatePopup && <DuplicatePopup searchClient={searchClient} indexName={ALGOLIA_BASE_INDEX_NAME} />}
    <RecommenderPopup results={popupData ?? []} eventingOverrides={popupEventing} />
    <SubmissionSlideOut />
    <JoEmbeddedRecommender results={recommenderData ?? []} eventingOverrides={popupEventing ?? {}} />
    {dcsConsolidationResults?.length > 0 ? (
      <ResultsList
        header="More Matches For You"
        subheader={`These schools offer programs in ${subject} or areas closely related to this subject.`}
        results={exactResults}
        borrowedResults={consolidatedResults}
        showUgToGradResultsPageABTest={showUgToGradResultsPageABTest}
      />
    ) : (
      ((showEmbeddedRecommender && recommenderData?.length && recommenderData?.length < 1) ||
        !showEmbeddedRecommender) &&
      unborrowedMatches?.length < 1 && <NoResults />
    )}
    {unborrowedMatches?.length > 0 && (
      <ResultsList
        isRelatedResults
        header="Related Results"
        subheader={`These schools offer similar programs to ${subject}.`}
        results={unborrowedMatches}
      />
    )}
    {isComparisonTest && (
      <>
        <JoComparisonBanner />
        <JoComparisonModal />
      </>
    )}

    <div className={styles.banners}>
      {showUserExperienceSurvey && !showRecommenderPopup && <UserExperienceSurvey />}
    </div>
  </>
);

export default JoV3EduResultsUI;
